module.exports = __webpack_public_path__ + "img/image-password.3c8deda4.png";